module.exports = __webpack_public_path__ + "static/img/d2.82eebbf0.webp";